import {
  Button,
  Menu,
  MenuItem,
  Typography,
  ListItemIcon,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { styled, useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { GetMachineTypeIcon } from "../utils/systemInfo";
const StyledMenu = styled((props) => <Menu {...props} />)(({ theme }) => ({
  "& .MuiPaper-root": {
    backgroundColor: theme.palette.secondary.dark,
    color: theme.palette.custom.light,
    maxHeight: "300px",
  },
}));
const StyleMachineSpan = styled((props) => <span {...props} />)(
  ({ theme }) => ({
    color: theme.palette.custom.text,
    fontSize: "1rem",
  })
);
export default function FleetSelect(props) {
  const { label, onChange, attributes, rows } = props;
  const groups = createSelectGroups();
  const theme = useTheme();
  const [anchorMachine, setAnchorMachine] = useState(null);

  function createSelectGroups() {
    const result = [];

    for (const attr of attributes) {
      const values = [...new Set(rows.map((obj) => obj[attr.id]))];
      result.push({ ...attr, values });
    }
    return result;
  }
  const handleOpenMachineMenu = (event) => {
    console.log("machine", groups, event.currentTarget);
    setAnchorMachine(event.currentTarget);
  };
  const handleOnChange = (item) => {
    if (onChange) {
      const selectedValue = item;
      const selectedOption = groups.find((group) =>
        group.values?.includes(selectedValue)
      );
      onChange(item, selectedOption?.id);
    }
  };
  const handleCloseMachineMenu = () => {
    setAnchorMachine(null);
  };
  return (
    <>
      <Tooltip title="Types">
        <Button
          variant="text"
          onClick={handleOpenMachineMenu}
          endIcon={
            <KeyboardArrowDownIcon
              sx={{
                fontSize: { xs: "30px", sm: "45px" },
                color: theme.palette.custom.text,
              }}
            />
          }
        >
          <StyleMachineSpan>{label}</StyleMachineSpan>
        </Button>
      </Tooltip>
      <StyledMenu
        id="menu-appbar"
        anchorEl={anchorMachine}
        open={Boolean(anchorMachine)}
        onClose={handleCloseMachineMenu}
        keepMounted
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem key={"all"} onClick={() => handleOnChange("")}>
          <ListItemIcon>
            <div style={{ width: "30px" }} />
          </ListItemIcon>
          <Typography textAlign="center">{"All"}</Typography>
        </MenuItem>
        {groups?.flatMap((group) =>
          group.values?.map((item) => (
            <MenuItem
              key={item}
              id={group.name}
              onClick={() => handleOnChange(item)}
            >
              <ListItemIcon>
                {item !== "All" && (
                  <div
                    style={{ width: "30px" }}
                    dangerouslySetInnerHTML={{
                      __html: GetMachineTypeIcon(item).replace(
                        "theme.palette.custom.text",
                        theme.palette.custom.text
                      ),
                    }}
                  />
                )}
              </ListItemIcon>
              <Typography textAlign="center">{item || ""}</Typography>
            </MenuItem>
          ))
        )}
      </StyledMenu>
    </>
  );
}
FleetSelect.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  attributes: PropTypes.array,
  rows: PropTypes.array,
};
